module.exports = __webpack_public_path__ + "img/business.f94bf9b6.png";